var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { getRequestConfig, spliceUrl } from './utils.js';
import { baseRequest } from './axios.js';
import { DEFAULT_METHOD } from './constants.js';
const cancelTokenSources = new Map();
export class EtransferRequest {
    constructor() {
        this._baseRequest = baseRequest;
    }
    post(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._baseRequest.post(url, data, config);
        });
    }
    get(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._baseRequest.get(url, config);
        });
    }
    send(base, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const _b = getRequestConfig(base, config) || {}, { method = DEFAULT_METHOD, query = '', url, cancelTokenSourceKey } = _b, axiosConfig = __rest(_b, ["method", "query", "url", "cancelTokenSourceKey"]);
            const source = axios.CancelToken.source();
            if (cancelTokenSourceKey) {
                if (cancelTokenSources.has(cancelTokenSourceKey)) {
                    (_a = cancelTokenSources.get(cancelTokenSourceKey)) === null || _a === void 0 ? void 0 : _a.cancel();
                }
                cancelTokenSources.set(cancelTokenSourceKey, source);
            }
            return yield this._baseRequest(Object.assign(Object.assign({}, axiosConfig), { url: url || spliceUrl(typeof base === 'string' ? base : base.target, query), method, cancelToken: source.token }));
        });
    }
    setHeaders(key, value) {
        this._baseRequest.defaults.headers.common[key] = value;
    }
    setConfig(key, value) {
        this._baseRequest.defaults[key] = value;
    }
}
